<template>
    <div>
        <div>
            <router-view class="mx-3" />
        </div>
    </div>
</template>

<script>
export default {

}
</script>


<style>
    
</style>